import { MessageGroup } from "@chatscope/use-chat/dist/MessageGroup";
import { useTranslation } from "react-i18next";

import { MessageContainer } from "./MessageContainer";
import moment from "moment";
import { useChatScroll } from "../../hooks/useChatScroll";
type ChatBoxContainerProps = {
  messagesList: MessageGroup[];
  showChatList: boolean;
};
export default function ChatBoxContainer(props: ChatBoxContainerProps) {
  const { messagesList, showChatList } = props;
  const LocalBasePath = "page.chat";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const messagesContainerRef = useChatScroll({ messagesList, showChatList });

  return (
    <div className="w-full    h-full">
      {messagesList.length ? (
        messagesList.map((message) => {
          return (
            <div className="w-full h-full md:py-8">
              <div className="relative py-3.5">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-b border-gray-300"></div>
                </div>
                <div className="relative flex justify-center">
                  <span className="bg-white px-4 text-sm text-gray-400">
                    {moment(message?.messages[0]?.createdTime).format(
                      "dddd D/M/YYYY"
                    )}
                  </span>
                </div>
              </div>
              <div className="w-full flex flex-col gap-2">
                <MessageContainer
                  key={message.id}
                  direction={message.direction}
                  messageList={message}
                />
              </div>
            </div>
          );
        })
      ) : (
        <div className="w-full h-full flex py-4 flex-col justify-end items-center ">
          <p className="text-gray-400 text-sm">{t("sendMessage")}</p>
        </div>
      )}
      <div
        ref={messagesContainerRef as React.MutableRefObject<HTMLDivElement>}
      />
    </div>
  );
}
